import axios from "axios";

const API_BASE_URL = "https://sms.dmtechnologies.in/api/index.php/v1";
// const API_BASE_URL = "/api/index.php/v1";
export const branch_id = 663;
export const active = "1";
export const Inactive = "0,-2,4,-6,-4";

// CAS filter options
export const CAS_OPTIONS = [
  {
    value: "9",
    label: "STB",
    icon: <img src="/smart-tv.png" alt="STB" width={18} height={18} />,
    color: "#8b5cf6",
  },
  {
    value: "5",
    label: "ONT",
    icon: <img src="/wifi-router.png" alt="ONT" width={18} height={18} />,
    color: "#3b82f6",
  },
  {
    value: "2",
    label: "APP",
    icon: <img src="/tv.png" alt="APP" width={18} height={18} />,
    color: "#10b981",
  },
  {
    value: "",
    label: "All Types",
    icon: (
      <img src="/music-library.png" alt="All Types" width={18} height={18} />
    ),
    color: "#6b7280",
  },
];

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

// ─── Auth ─────────────────────────────────────────────────────────────────────

export const loginAPI = async (username, password) => {
  try {
    const response = await apiClient.post("/teplay-hook/auth?vr=cdeskweb1.0", {
      LoginForm: { username: username.trim(), password },
    });
    return response.data;
  } catch (error) {
    throw {
      message: error.response?.data?.message || error.message || "Login failed",
      status: error.response?.status,
      error,
    };
  }
};

export const logoutAPI = async () => {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    return true;
  } catch (error) {
    console.error("Logout error:", error);
    return false;
  }
};

export const getAuthToken = () => localStorage.getItem("token");
export const isAuthenticated = () => !!localStorage.getItem("token");
export const getCurrentUser = () => localStorage.getItem("username");

// ─── Helper: build params with cas support ───────────────────────────────────

const buildParams = ({
  branch_id: bid,
  type,
  city_id,
  distributor_id,
  operator_id,
  cas,
  dateType,
} = {}) => {
  const params = new URLSearchParams();
  if (bid !== undefined) params.append("filter[branch_id]", bid);
  if (type) params.append("filter[type]", type);
  if (city_id) params.append("filter[city_id]", city_id);
  if (distributor_id) params.append("filter[distributor_id]", distributor_id);
  if (operator_id) params.append("filter[operator_id]", operator_id);
  if (cas) params.append("filter[cas]", cas);
  if (dateType) params.append("filter[dateType]", dateType);
  return params;
};

// ─── Manufacturer ─────────────────────────────────────────────────────────────

export const getManufacturerDetailsAPI = async () => {
  const token = getAuthToken();
  const response = await fetch(`${API_BASE_URL}/teplay-hook/dm-po-details`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch manufacturer details");
  return data;
};

// ─── Device ───────────────────────────────────────────────────────────────────

export const getDeviceDetails = async () => {
  const token = getAuthToken();
  const response = await fetch(`${API_BASE_URL}/teplay-hook/dm-device-info`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch device details");
  return data;
};

export const getDmPoDetails = async () => {
  const token = getAuthToken();
  const response = await fetch(`${API_BASE_URL}/teplay-hook/dm-po-details`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch device details");
  return data;
};

export const saveDmPoDetails = async (data) => {
  const token = getAuthToken();
  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/dm-po-details-save`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    },
  );
  const result = await response.json();
  if (!result.success)
    throw new Error(result.message || "Failed to save PO details");
  return result;
};

// ─── Warehouse ────────────────────────────────────────────────────────────────

export const getOverallWarehouseStock = async (
  bid,
  type = "",
  city_id = "",
  distributor_id = "",
  operator_id = "",
  cas = "",
) => {
  const token = getAuthToken();
  const params = buildParams({
    branch_id: bid,
    type,
    city_id,
    distributor_id,
    operator_id,
    cas,
  });
  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/dm-inventory-details?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch warehouse details");
  return data;
};

// ─── User Count ───────────────────────────────────────────────────────────────

export const getOverallUserCount = async (
  type,
  city_id = "",
  distributor_id = "",
  operator_id = "",
  cas = "",
) => {
  const token = getAuthToken();
  const params = buildParams({
    branch_id,
    type,
    city_id,
    distributor_id,
    operator_id,
    cas,
  });
  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/dis-lco-count?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch user count");
  return data;
};

// ─── User Status ──────────────────────────────────────────────────────────────

export const getAllStatus = async (
  status,
  city_id = "",
  distributor_id = "",
  operator_id = "",
  cas = "",
) => {
  const token = getAuthToken();
  const params = buildParams({
    branch_id,
    city_id,
    distributor_id,
    operator_id,
    cas,
  });
  const typeFilter =
    status === "active"
      ? `&filter[status]=${active}`
      : `&filter[status]=${Inactive}`;
  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/over-all-status?${params.toString()}${typeFilter}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success) throw new Error(data.message || "Failed to fetch status");
  return data;
};

// ─── Distributor ──────────────────────────────────────────────────────────────

export const getAllDistributor = async () => {
  const token = getAuthToken();
  const response = await fetch(
    `${API_BASE_URL}/operator/list?filter[branch_id]=${branch_id}&filter[type]=2&vr=cdeskweb1.0`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch distributor list");
  return data;
};

// ─── LCO ──────────────────────────────────────────────────────────────────────

export const getLcoList = async (distributor_id) => {
  const token = getAuthToken();
  const response = await fetch(
    `${API_BASE_URL}/operator/list?filter[branch_id]=${branch_id}&filter[distributor_id]=${distributor_id}&filter[type]=3&vr=cdeskweb1.0`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch LCO list");
  return data;
};

// ─── LCO (all, no distributor filter) ────────────────────────────────────────

export const getAllLcoList = async () => {
  const token = getAuthToken();
  const response = await fetch(
    `${API_BASE_URL}/operator/list?fields=id,name,code&expand=type_lbl,status_lbl,branch_lbl,distributor_lbl&notfilter[type]=0,1,2`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch all LCO list");
  return data;
};

// ─── Cities ───────────────────────────────────────────────────────────────────

export const getAllCities = async () => {
  const token = getAuthToken();
  const response = await fetch(
    `${API_BASE_URL}/administrative-division?filter[type]=3&page=1&per-page=5000&vr=cdeskweb1.0`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success) throw new Error(data.message || "Failed to fetch cities");
  return data;
};

// ─── Daywise Status ───────────────────────────────────────────────────────────

export const getDaywiseStatus = async (
  dateType = "TODAY",
  city_id = "",
  distributor_id = "",
  operator_id = "",
  cas = "",
) => {
  const token = getAuthToken();
  const params = buildParams({
    branch_id,
    dateType,
    city_id,
    distributor_id,
    operator_id,
    cas,
  });
  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/daywise-status?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch daywise status");
  return data;
};
// ─── Cities Overview ──────────────────────────────────────────────────────────

export const getInventoryCities = async (
  region = "",
  cas = "",
  branch_id = "",
) => {
  const token = getAuthToken();
  const params = new URLSearchParams();

  if (region) params.append("filter[region]", region);
  if (cas) params.append("filter[cas]", cas);
  if (branch_id) params.append("filter[branch_id]", branch_id);

  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/dm-inventory-cities?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch cities inventory");
  return data;
};

// ─── Sales Manager ────────────────────────────────────────────────────────────

export const getSalesManagers = async () => {
  const token = getAuthToken();
  const response = await fetch(
    `${API_BASE_URL}/list/salesManager?fields=id,name&vr=cdeskweb1.0`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch sales managers");
  return data;
};

export const setSalesTarget = async ({ sales_manager_id, month, target }) => {
  const token = getAuthToken();
  const response = await fetch(`${API_BASE_URL}/teplay-hook/set-sales-target`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ sales_manager_id, month, target }),
  });
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to save sales target");
  return data;
};

export const getSalesOverview = async (sales_manager_id, month) => {
  const token = getAuthToken();
  const params = new URLSearchParams();
  if (sales_manager_id) params.append("sales_manager_id", sales_manager_id);
  if (month) params.append("month", month);

  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/sales-overview?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch sales overview");
  return data;
};

export const downloadSalesOverviewExport = async (sales_manager_id, month) => {
  const token = getAuthToken();
  const params = new URLSearchParams();
  if (sales_manager_id) params.append("sales_manager_id", sales_manager_id);
  if (month) params.append("month", month);

  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/sales-overview-export?${params.toString()}`,
    { method: "GET", headers: { Authorization: `Bearer ${token}` } },
  );

  if (!response.ok) throw new Error("Failed to export sales overview");

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `sales-overview-${sales_manager_id}-${month}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const getSalesOverviewOperatorDetail = async (
  sales_manager_id,
  month,
) => {
  const token = getAuthToken();
  const params = new URLSearchParams();
  if (sales_manager_id) params.append("sales_manager_id", sales_manager_id);
  if (month) params.append("month", month);

  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/sales-overview-operator-detail?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(data.message || "Failed to fetch operator detail");
  return data;
};

// ─── NEW: All-managers operator detail (for the All Managers PDF export) ────

export const getSalesOverviewAllOperatorDetail = async (month) => {
  const token = getAuthToken();
  const params = new URLSearchParams();
  if (month) params.append("month", month);

  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/sales-overview-all-operator-detail?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(
      data.message || "Failed to fetch all-managers operator detail",
    );
  return data;
};

export const getSalesOverviewAll = async (month) => {
  const token = getAuthToken();
  const params = new URLSearchParams();
  if (month) params.append("month", month);

  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/sales-overview-all?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = await response.json();
  if (!data.success)
    throw new Error(
      data.message || "Failed to fetch all-managers sales overview",
    );
  return data;
};

export const downloadSalesOverviewExportAll = async (month) => {
  const token = getAuthToken();
  const params = new URLSearchParams();
  if (month) params.append("month", month);

  const response = await fetch(
    `${API_BASE_URL}/teplay-hook/sales-overview-all-export?${params.toString()}`,
    { method: "GET", headers: { Authorization: `Bearer ${token}` } },
  );

  if (!response.ok)
    throw new Error("Failed to export all-managers sales overview");

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `sales-overview-all-managers-${month}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export default apiClient;
